<template>
  <div class="relative flex w-full">
    <div class="flex w-full">
      <div class="w-12 ml-3 mr-2 w-12 items-center flex justify-center">
        <BarcodeIconLabel :clickable="true" :barcodeTypeInfo="barcodeTypeInfo" @icon:click="redirectTo" />
      </div>
      <div class="flex-grow">
        <div>
          <div class="cursor-pointer h-4 flex items-center text-xs text-gray-400" @click="redirectTo">
            {{ subLabel }}
          </div>
          <div class="h-8 flex items-center">
            {{ label }}
          </div>
        </div>
      </div>
    </div>
    <div class="action-menu"><slot name="action-menu"></slot></div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import BarcodeIconLabel from '../components/BarcodeIconLabel.vue'
import { IBarcodeDefinitionType } from '@/utils/types/fieldDefinition'

@Options({
  components: { BarcodeIconLabel },
  emits: ['subLabel:click'],
})
export default class BarcodeInfoLabel extends Vue {
  @Prop({ type: Object }) readonly barcodeTypeInfo!: IBarcodeDefinitionType
  @Prop({ type: String }) readonly label!: string
  @Prop({ type: String }) readonly subLabel!: string

  redirectTo() {
    this.$emit('subLabel:click')
  }
}
</script>

<style scoped>
.action-menu {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%);
}
</style>
